import { createAction, createSlice } from '@reduxjs/toolkit';

import { SummarizedWorkOrder } from '@mfe/shared/schema-types';

import { filterByWorkOrderType } from '../shared';
import { WorkOrderTypes } from '../types';

type WorkOrderState = {
  workOrders: SummarizedWorkOrder[] | null;
  loading: boolean;
  error: null | boolean | string;
  installDate: string | null;
  schedule: SummarizedWorkOrder['schedule'] | null;
};

const initialState: WorkOrderState = {
  workOrders: null,
  loading: false,
  error: null,
  installDate: null,
  schedule: null,
};

export const workOrdersSlice = createSlice({
  name: 'workOrders',
  initialState,
  reducers: {
    getWorkOrders: (state) => {
      state.loading = true;
    },
    setWorkOrders: (state, action) => {
      const installWorkOrders = filterByWorkOrderType(action.payload, [
        WorkOrderTypes.INSTALL,
        WorkOrderTypes.COMMERCIAL_INSTALL,
      ]);

      const installationWorkOrder = installWorkOrders?.[0];
      const installDate: string = installationWorkOrder?.schedule?.from as string;

      state.loading = false;
      state.workOrders = action.payload;
      state.installDate = installDate;
      state.schedule = installationWorkOrder?.schedule;
    },
    setWorkOrdersError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const displayServiceCallAlert = createAction<SummarizedWorkOrder>('workOrders/displayServiceCallAlert');

export const { getWorkOrders, setWorkOrders, setWorkOrdersError } = workOrdersSlice.actions;

export const selectWorkOrders = (state: { workOrders: WorkOrderState }) => state.workOrders;
